import { RequiredArticle } from '../Article';
import { ArticleDefinitionMapper } from './ArticleDefinitionMapper';
import { articleService } from '../../services/articleService';

export class RequiredConnectArticleMapper {
  static toDomain = (dto: CoreServiceAPI.RequiredConnectArticleDto): RequiredArticle =>
    articleService.instantiateRequiredArticle(
      ArticleDefinitionMapper.toDomain(dto.requiredArticle),
      dto.amount
    );
}
